import React, { Component } from "react";
import ReactPlayer      from 'react-player'
import uniqueId         from 'lodash/uniqueId';

export default class YouTubePlayer extends Component {

    constructor(props) {
        super(props)

        /*this.state = {
            showModalSimple:  false,
        };*/
    }

    // Docs: https://www.npmjs.com/package/react-player //
    render() {
        var yt_id      = this.props.yt_id;
            
        //var width      = this.props.width;
        //var yt_img_src = "https://img.youtube.com/vi/"+yt_id+"/1.jpg";
        var yt_url     = 'https://www.youtube.com/watch?v='+yt_id;
        return (
            <div>
                { /*}<img src = {yt_img_src} width = "100"/>*/ }
                <ReactPlayer url={yt_url}  width="100%" height="280px"/>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/YouTubePlayer.js